import classNames              from 'classnames';
import * as React              from 'react';
import { useTranslation }      from 'react-i18next';
import { Link, useLocation }   from 'react-router-dom';
import { LocalStorageService } from 'ts-storage-service';

import '../style.scss';

import needReset                 from '../../../common/tools/need-reset';
import ConsultationBlock         from '../../../components/consultationBlock';
import Preloader                 from '../../../components/containers/preloader';
import DeleteCompareModal        from '../../../components/deleteCompareModal';
import ClearIcon                 from '../../../components/icons/ClearIcon';
import PrevPageArrow             from '../../../components/icons/PrevPageArrow';
import Meta                      from '../../../components/meta';
import PageHeader                from '../../../components/pageHeader';
import { useCatalog }            from '../../../providers/catalog';
import { useCommon }             from '../../../providers/common';
import { useCompare }            from '../../../providers/compare';
import { useDeleteCompareModal } from '../../../providers/deleteCompareModal';

import CompareTable from './CompareTable';

const Compare = function() {
  const location = useLocation();
  const { t }    = useTranslation();

  const catalog            = useCatalog();
  const common             = useCommon();
  const compare            = useCompare();
  const deleteCompareModal = useDeleteCompareModal();

  const ls = new LocalStorageService();

  const [currentOffer, setCurrentOffer] = React.useState({});
  const [loading, setLoading]           = React.useState(true);

  const comparePage = React.useMemo(() => {
    return common.pages.find((page) => {
      return page.template === 'compare';
    });
  }, [common.pages]);
  const doorsType   = React.useMemo(() => {
    return new URLSearchParams(location.search).get('type') || 'entrance';
  }, [location.search]);

  const clearOffers               = React.useCallback((isSingleDoor) => {
    if (isSingleDoor) {
      const newCompareOffers = {
        ...compare.tradeOffers,
        [doorsType]: compare.tradeOffers[doorsType].filter((offer) => {
          return offer !== currentOffer.offerId;
        }),
      };

      compare.setCompareTradeOffers(newCompareOffers);

      ls.setData('compare_offers', newCompareOffers);
    } else {
      compare.setCompareTradeOffers(({
        entrance: [],
        interior: [],
      }));

      ls.removeData('compare_offers');
    }
  }, [currentOffer.offerId, doorsType, compare.tradeOffers]);
  const handleCatalogResetOnClick = React.useCallback((url) => {
    if (needReset(url)) {
      catalog.resetFilter();
      catalog.getCatalogItems(url);
    }
  }, []);

  React.useEffect(() => {
    const storageData = ls.getData('compare_offers');

    if (storageData) {
      compare.setCompareTradeOffers(storageData);
    }

    setLoading(false);
  }, []);
  React.useEffect(() => {
    if (compare.tradeOffers[doorsType]?.length > 0) {
      compare.getCompareList(compare.tradeOffers[doorsType]);
    }
  }, [compare.tradeOffers, doorsType]);

  return (
    <>
      <div className={'page-content'}>
        <Meta {...comparePage?.meta} />
        <div className={classNames('compare_header_wrapper', { empty: !compare.tradeOffers[doorsType]?.length })}>
          <PrevPageArrow />
          <PageHeader>{comparePage.label}</PageHeader>
          <div
            className={'clear_compare'}
            onClick={() => {
              deleteCompareModal.showModal(false);
            }}
          >
            {(!!compare.tradeOffers[doorsType]?.length && !loading) && (
              <>
                <p>{t('client_clear_list')}</p>
                <ClearIcon />
              </>
            )}
          </div>
        </div>
        <main className={comparePage.template}>
          <section className={'compare_table_wrapper'}>
            {!!compare.tradeOffers[doorsType]?.length
              ? (
                <CompareTable
                  compareOffers={compare.items}
                  handleCatalogResetOnClick={handleCatalogResetOnClick}
                  isInterior={doorsType === 'interior'}
                  setCurrentOffer={setCurrentOffer}
                />
              )
              : !loading
                ? (
                  <div className={'compare_offers_not_found'}>
                    <p>{t('client_compare_not_found')}</p>
                    <Link
                      className={'btn fill'}
                      onClick={() => {
                        handleCatalogResetOnClick('/vhodnye-dveri');
                      }}
                      to={'/vhodnye-dveri'}
                    >{t('btn_add_doors')}</Link>
                  </div>
                )
                : null
            }
          </section>
          <ConsultationBlock />
        </main>
      </div>
      <DeleteCompareModal
        clearOffers={clearOffers}
        currentOfferLabel={currentOffer.label}
      />
      {(loading || compare.loading) && <Preloader />}
    </>
  );
};

export default Compare;